// ***** FOUNDATION-BASED COMPONENTS *****

//FUNCTION TO SWAP OUT VIDEOS FOR THE VIDEO GALLERY COMPONENT

// Create a private scope just for initializing the videos
//
// This gives us a private scope, so we can create extra variables w/o polluting
// the rest of our code.
jQuery(function ($) {

  // Select each video gallery container, and loop through each with its own private context
  $('.news_video_container').each(function () {
    var primaryVideo = $("#featured_vid");

    // Select this video container
    var jVideoContainer = $(this);

    // Check whether to use truncation for paragraphs
    var bUseTruncation = !!jVideoContainer.data('videoUseTruncation');

    // Height of two lines of text
    var iTestHeight = null;

    // Select the video gallery quote container
    var jVideoGalleryQuote = jVideoContainer.find('#video_gallery_quote_container');

    // Select all the video items ONCE
    var jVideoItems = jVideoContainer.find('.scroll_item');

    // Select the first video
    var jFirstVideo = jVideoItems.first();

    // Select the parent of the video items ONCE
    var jVideoItemsParent = jFirstVideo.parent();

    // Calculate additional padding in parent ONCE
    var iScrollParentPadding = (jVideoItemsParent.innerHeight() - jVideoItemsParent.height());

    // Select the featured video ONCE
    var jFeaturedVideo = jVideoContainer.find('.featured_video');

    // Iterate over each video item, each with its own private scope
    jVideoItems.each(function (i, e) {

      // Make sure all our variables stay in this scope,
      // instead of attaching to the window object
      var jOtherVideos, jThisVideo, jThisVideoDetails, jVideoShortDetails, id, vidUrl;

      // Select video ONCE and only ONCE
      jThisVideo = $(this);

      // Select other video items
      jOtherVideos = jVideoItems.not(jThisVideo);

      // Select the date details container in this video item
      jVideoShortDetails = jThisVideo.find('.video_short_details');

      // Select the full details container in this video item
      jThisVideoDetails = jThisVideo.find('.video_full_details');

      // Set up the truncated "short" details if needed
      if (bUseTruncation) {
        jVideoShortDetails.append(jThisVideoDetails.contents().clone());
        var jCaptionParagraph = jVideoShortDetails.find('.video_caption_paragraph');
        if (iTestHeight === null) {
          var jTestParagraph = jCaptionParagraph.clone().html('t<br/>t');
          jTestParagraph.insertAfter(jCaptionParagraph);
          iTestHeight = jTestParagraph.height();
          jTestParagraph.remove();
        }
        jCaptionParagraph.find('br:gt(0)').remove();

        var strOriginalHtml = jCaptionParagraph.html();
        if (strOriginalHtml) {
          var aTokenizedStr = strOriginalHtml.match(/(\s*<br\s*\/?>\s*|\s*\S+\s*)/gi);
          //console.log(aTokenizedStr);
          var iTokenIndex = 0;
          jCaptionParagraph.html('');
          var strOldHtml = '';
          var strCurrentHtml = '';
          var strDisplayHtml = '';
          while (jCaptionParagraph.height() <= iTestHeight && iTokenIndex < aTokenizedStr.length) {
            strOldHtml = strCurrentHtml;
            strCurrentHtml += aTokenizedStr[iTokenIndex++];
            strDisplayHtml = strCurrentHtml.replace(/\s*$/, '');
            if (iTokenIndex < aTokenizedStr.length) {
              strDisplayHtml = strDisplayHtml.replace(/\W*$/, '');
              strDisplayHtml += '..';
              if (strDisplayHtml.charAt(strDisplayHtml.length - 3) !== '.') {
                strDisplayHtml += '.';
              }
            }
            jCaptionParagraph.html(strDisplayHtml);
          }
          if (jCaptionParagraph.height() > iTestHeight) {
            strDisplayHtml = strOldHtml.replace(/\s*$/, '');
            if (iTokenIndex < aTokenizedStr.length) {
              strDisplayHtml = strDisplayHtml.replace(/\W*$/, '');
              strDisplayHtml += '..';
              if (strDisplayHtml.charAt(strDisplayHtml.length - 3) !== '.') {
                strDisplayHtml += '.';
              }
            }
            jCaptionParagraph.html(strDisplayHtml);
          }
        }
      }

      // Get the video's ID and split it ONCE (default to empty string to prevent JS errors)
      id = (jThisVideo.attr('id') || '').split('-');

      // Set the video URL for this particular video ONCE
      vidUrl = window.location.protocol + '//player.vimeo.com/video/' + id[1] + '?color=4f8abe';

      // If this is the first video item, treat it as  selected
      if (i < 1) {
        // Show full details/hide date details for this video
        jThisVideoDetails.show();
        jVideoShortDetails.hide();

        // Update the video gallery quote
        jVideoGalleryQuote.html(jThisVideo.data('videoQuote'));
      } else {
        jThisVideoDetails.hide();
        jVideoShortDetails.show();
      }

      // Set the video URL when the item is clicked
      jThisVideo.click(function () {
        // Exit early if this video is already selected
        if (jThisVideo.hasClass('active_video_item')) {
          // Scroll to original if hide/show won't happen
          jVideoItemsParent.animate({
            scrollTop: jThisVideo.offset().top - jFirstVideo.offset().top + iScrollParentPadding//8px to account for padding
          });
          return;
        }

        // Add the class to this video item
        jThisVideo.addClass('active_video_item');

        // Remove the class from all video items EXCEPT this one
        jOtherVideos.removeClass('active_video_item');

        // Hide full details/show date details for other videos
        jOtherVideos.find('.video_short_details').show();
        jOtherVideos.find('.video_full_details').hide();

        if(jThisVideo.attr('data-quote')) {
          $('#video_gallery_quote_container').html(jThisVideo.data('quote'));
        }
        else {
          $('#video_gallery_quote_container').empty();
        }

        // Show full details/hide date details for this video,
        // if there are additional details
        if (jThisVideoDetails.children().length > 0) {
          jThisVideoDetails.show();
          jVideoShortDetails.hide();
        }

        // Update the video gallery quote
        jVideoGalleryQuote.html(jThisVideo.data('videoQuote'));

        // Scroll after hide/show to keep consistent top values
        jVideoItemsParent.animate({
          scrollTop: jThisVideo.offset().top - jFirstVideo.offset().top + iScrollParentPadding//8px to account for padding
        }).promise().always(function () {
          // Set the featured video's 'src' attribute to this video
          if (primaryVideo.hasClass('reviews')) {
            var newId = jThisVideo.data('id');
            primaryVideo.attr('href', 'http://vimeo.com/' + newId);
            loadVimeoThumbnail(newId);
          } else {
            jFeaturedVideo.attr('src', vidUrl);
          }
        });
      });
    });
  });
}, (jQuery));

jQuery(document).ready(function ($) {
  $(".print_item").on("click", function () {
    var modal_id = "#" + $(this).data("reveal-id");
    if (!$(modal_id).hasClass('active')) {
      $(modal_id).addClass('active');
      $("#reveal-modal-bg").addClass('active');
    }
  });
  
  $("#reveal-modal-bg").on("click", function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(".reveal-modal").removeClass('active');
    }
  });

  $(".reveal-modal").on("click", function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $("#reveal-modal-bg").removeClass('active');
    }
  });

  // Change article gallery display based on browser width
  if (document.documentElement.clientWidth < 767) {
    $("#print_slider").attr("data-cycle-carousel-visible", 1);
    $("#print_slider").attr("data-cycle-carousel-hops", 1);
  } else if (document.documentElement.clientWidth >= 767 && document.documentElement.clientWidth < 992) {
    $("#print_slider").attr("data-cycle-carousel-visible", 3);
    $("#print_slider").attr("data-cycle-carousel-hops", 3);
  } else if (document.documentElement.clientWidth >= 992) {
    $("#print_slider").attr("data-cycle-carousel-visible", 4);
    $("#print_slider").attr("data-cycle-carousel-hops", 4);
  }

  // Change video gallery display based on browser width
  if (document.documentElement.clientWidth < 400) {
    $( "#mobile_video_bottom" ).attr( "data-cycle-carousel-visible", 3);
    $( "#mobile_video_bottom" ).attr( "data-cycle-carousel-hops", 3);
  }
  else if (document.documentElement.clientWidth >= 401) {
    $( "#mobile_video_bottom" ).attr( "data-cycle-carousel-visible", 6);
    $( "#mobile_video_bottom" ).attr( "data-cycle-carousel-hops", 6);
  }

}, (jQuery));

jQuery(function ($) {

  var jOptinForm = $('#optinform');
  var optin_country = $('#optin_country');
  var optin_connect = $('#optin_connect');
  var optin_direct_mail = $('#optin_direct_mail');
  var info_me_row = $('#info-me-row');
  var email_me_row = $('#email-me-row');
  var connect_me_row = $('#connect-me-row');
  var submitButton = jOptinForm.find('#optin-send');

  if (optin_country.val() === 'US') {
    info_me_row.show();
    email_me_row.show();
    connect_me_row.show();
  } else {
    info_me_row.hide();
    email_me_row.hide();
    connect_me_row.hide();
  }

  // Toggle the 'connect' checkbox and reset the required fields.
  optin_country.on('change', function () {

    if (optin_country.val() === 'US') {
      info_me_row.show();
      email_me_row.show();
      connect_me_row.show();
    } else {
      // Clear the checkbox
      optin_direct_mail.prop('checked', false);
      setRequiredFields(jOptinForm, $('#optin_connect'));

      if (optin_direct_mail.prop('checked') == true) {
        setRequiredFields(jOptinForm, $('#optin_direct_mail'));
      }
      info_me_row.hide();
      email_me_row.hide();
      connect_me_row.hide();
    }
  });

  // Build the full phone number
  submitButton.on('click', function () {
    var phone1 = jOptinForm.find('#optin_phone_1').val();
    var phone2 = jOptinForm.find('#optin_phone_2').val();
    var phone3 = jOptinForm.find('#optin_phone_3').val();
    var phone = jOptinForm.find('#optin_phone');
    phone.val(phone1 + phone2 + phone3);
  });


  jOptinForm.on('click', 'input[type=checkbox]', function (e) {
    setRequiredFields(jOptinForm, $(this));
  });

  jOptinForm.on('click', optin_connect, function (e) {
    if (optin_direct_mail.prop('checked') == true) {
      setRequiredFields(jOptinForm, optin_direct_mail);
    }
  });

  jOptinForm.on('click', optin_direct_mail, function (e) {

    if (optin_connect.prop('checked') == true) {
      setRequiredFields(jOptinForm, optin_connect);
    }

  });


  jOptinForm.on('submit', function (e) {
    e.preventDefault();
  });

//  window.PCFoundationFormUtils.applyAbideValidation(jOptinForm, '#F4E1A9');

  jOptinForm.on('invalid', function (e) {
    // Prevent the default form action
    e.preventDefault();

    if (!validateOptinSelection(jOptinForm)) {
      //This doesn't make any sense, but I didn't do it...
    }
  });

  jOptinForm.on('valid', function (e) {
    // Prevent the default form action
    e.preventDefault();

    if (!validateOptinSelection(jOptinForm))
      return;

    // Select the loading indicator and submit button elements
    var jIndicator = jOptinForm.find('#optin-indicator');
    var jSubmitButton = jOptinForm.find('#optin-send');

    // // Show the loading indicator and disable/hide the submit button
    jIndicator.fadeIn('medium');
    jSubmitButton.prop('disabled', true).hide();

    // // Submit the inquiry form to the server via POST
    $.ajax({
      type: 'POST',
      url: $('#url').val() + "/scripts/processOptinForm.php",
      data: jOptinForm.serialize(),
      dataType: "json"

              // If successful, close the form, show a success message, and log the GA event
    }).done(function (data) {
      if (data.error != 0)
        return;

      _gaq.push(['_trackEvent', 'OptInForm', 'Submitted Optin Form']);
      if (data.connected == 1) {
        _gaq.push(['_trackEvent', 'OptInForm', 'Success', data.accountId]);
        _gaq.push(['_trackEvent', 'Conversions', 'Appointment Booked', data.accountId]);
      }

      ultherapyAnalytics.forward.conversion('pRsRCIy11V8QuOT2xQM'); //generic optin conversion

      // XXX: This line is used for redirects not yet integrated into the Foundation-based pages. (as of 1-17-2014)
      $('#user-thank-you').val(1);

      //  Floodlight tag for DFA
      var axel = Math.random() + "";
      var a = axel * 10000000000000;
      $('#iframe-anchor').html('<iframe src="http://3851032.fls.doubleclick.net/activityi;src=3851032;type=count196;cat=conve807;ord=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>');

      //  Close window. Uses the parent window function if it's embedded in an iFrame
      if (parent.location == window.location) {
        jSubmitButton.closest('[data-reveal]').foundation('reveal', 'close');
        setTimeout(function () {
          jOptinForm.find(':input:not(checkbox:first)').val(null);
          $('#optin_success_message').foundation('reveal', 'open');
        }, 500);
      } else {
        window.parent.closeSignup(true);
      }

      // On failure...
    }).fail(function () {
      // TODO: Decide what to do if the request fails

      // In all cases, remove the loading indicator and re-enable the submit button
    }).always(function () {
      jIndicator.fadeOut('medium');
      jSubmitButton.prop('disabled', false).show();
    });
  });
}, (jQuery));

function validateOptinSelection(jOptinForm) {
  // Run additional form validation - at least one checkbox required
  if (jOptinForm.find('input[type=checkbox]:checked').size() < 1) {
    jOptinForm.find("#optin_selection_error").show();
    return false;
  } else {
    jOptinForm.find("#optin_selection_error").hide();
    return true;
  }
}